interface ProcedureMethodExecutionInstance {
  procedureRunConditionReplicate: {
    procedureRunCondition: {
      name: string;
    };
  };
}

export default function getProcedureRunConditionName(
  procedureMethodExecutionInstance: ProcedureMethodExecutionInstance
): string {
  return procedureMethodExecutionInstance.procedureRunConditionReplicate.procedureRunCondition.name;
}
